import React from 'react';
import { createPortal } from 'react-dom';

/**
 * `createPortal` a `document.body` -- BUG REAL CORREGIDO 2026-09-28 (encontrado
 * probando en el navegador: el texto de un modal abierto desde el botón "Permisos"
 * de una fila de tabla no hacía wrap y se encimaba entre columnas). Causa: sin
 * portal, este modal se renderiza como descendiente DOM de la celda `<td>` que
 * disparó su apertura -- y `DataTable.jsx` pone `whitespace-nowrap` en TODAS las
 * celdas (para que las etiquetas de los botones de acción no hagan wrap ahí). Como
 * `white-space` es una propiedad heredable de CSS que ignora `position:fixed` (el
 * `position` solo afecta layout/pintado, no la cascada), el modal completo heredaba
 * `nowrap` de esa celda por más que sus propios elementos declararan
 * `break-words`/`whitespace-normal`. El portal saca el modal del árbol DOM de la
 * tabla por completo, evitando esta clase de herencia de estilos ambientales para
 * CUALQUIER modal futuro abierto desde una fila.
 */
export default function Modal({ open, onClose, title, children, footer, width = 'max-w-lg' }) {
  if (!open) return null;
  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className={`w-full ${width} bg-white rounded-xl shadow-xl max-h-[90vh] flex flex-col`}>
        <div className="flex items-center justify-between px-5 py-3 border-b border-slate-200">
          <h2 className="font-semibold text-slate-900">{title}</h2>
          <button onClick={onClose} className="text-slate-400 hover:text-slate-600 text-xl leading-none">&times;</button>
        </div>
        <div className="p-5 overflow-y-auto">{children}</div>
        {footer && <div className="px-5 py-3 border-t border-slate-200 flex justify-end gap-2">{footer}</div>}
      </div>
    </div>,
    document.body
  );
}
